import React from 'react'
import jwt_decode from "jwt-decode";
import { Card, Form, Input, Icon, Checkbox, Button, message, Divider } from 'antd';
import Fetch from '../Fetch';

const PageLogin = (props) => {
    const { getFieldDecorator } = props.form;
    const [loading, setLoading] = React.useState(false);
    const [waLoading, setWaLoading] = React.useState(false);
    const [showWaCode, setShowWaCode] = React.useState(false);
    const [waPhone, setWaPhone] = React.useState('');

    const getUserType = (token) => {
        const jwtDecoded = jwt_decode(token);
        return jwtDecoded.UserType;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        props.form.validateFields(async (err, values) => {
            if (!err) {
                setLoading(true);
                const result = await fetch(Fetch.getUrl('/auth'), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        username: values.username,
                        password: values.password,
                    })
                });
                const json = await result.json();
                if (result.status === 200) {
                    if (getUserType(json.access_token) > 3) {
                        message.error('User tidak diperkenankan untuk login web');
                        setLoading(false);
                    } else {
                        Fetch.setLoggedIn(json)
                        setTimeout(() => props.history.replace('/'), 500)
                    }
                } else {
                    message.error('Login failed: ' + json.error);
                    setLoading(false);
                }
            }
        });
    }

    const handleWhatsappCode = async () => {
        props.form.validateFields(['phone'], async (err, values) => {
            // Check if phone number is provided for WhatsApp login
            if (!values.phone || values.phone.trim() === '') {
                message.error('Please input your phone number for WhatsApp login!');
                return;
            }

            if (!err) {
                setWaLoading(true);
                try {
                    const result = await fetch(Fetch.getUrl('/auth/wa/code'), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            phone: values.phone
                        })
                    });
                    const json = await result.json();
                    if (result.status === 200) {
                        message.success('WhatsApp code sent successfully!');
                        setWaPhone(values.phone);
                        setShowWaCode(true);
                        setWaLoading(false);
                    } else {
                        message.error('Failed to send code: ' + (json.error || 'Unknown error'));
                        setWaLoading(false);
                    }
                } catch (error) {
                    message.error('Network error: ' + error.message);
                    setWaLoading(false);
                }
            }
        });
    }

    const handleWhatsappLogin = async () => {
        props.form.validateFields(['waCode'], async (err, values) => {
            if (!err) {
                setWaLoading(true);
                try {
                    const result = await fetch(Fetch.getUrl('/auth/wa/login'), {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            phone: waPhone,
                            code: values.waCode
                        })
                    });
                    const json = await result.json();
                    if (result.status === 200) {
                        if (getUserType(json.access_token) > 3) {
                            message.error('User tidak diperkenankan untuk login web');
                            setWaLoading(false);
                        } else {
                            message.success('Login successful!');
                            Fetch.setLoggedIn(json);
                            setTimeout(() => props.history.replace('/'), 500);
                        }
                    } else {
                        message.error('Login failed: ' + (json.error || 'Invalid code'));
                        setWaLoading(false);
                    }
                } catch (error) {
                    message.error('Network error: ' + error.message);
                    setWaLoading(false);
                }
            }
        });
    }

    return (
        <div style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: 300, padding: '70px 0' }}>
            <Card title="Login">
                <Form onSubmit={handleSubmit} className="login-form">
                    <Form.Item>
                        {getFieldDecorator('username', {
                            rules: [{ required: true, message: 'Please input your username!' }],
                        })(
                            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('password', {
                            rules: [{ required: true, message: 'Please input your Password!' }],
                        })(
                            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('remember', {
                            valuePropName: 'checked',
                            initialValue: true,
                        })(
                            <Checkbox>Remember me</Checkbox>
                        )}
                        <span className="span-click" style={{ float: 'right' }} href="">Forgot password</span>
                        <Button type="primary" htmlType="submit" style={{ width: '100%' }} loading={loading}>
                            Log in
                        </Button>
                    </Form.Item>

                    <Divider>OR</Divider>

                    <Form.Item>
                        {getFieldDecorator('phone', {
                            rules: [
                                { pattern: /^0[0-9]{8,14}$/, message: 'Phone number must start with 0 and contain 9-15 digits!' }
                            ],
                        })(
                            <Input
                                prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                placeholder="Phone Number (e.g., 081234567890) - Optional for WhatsApp login"
                                disabled={showWaCode}
                            />
                        )}
                    </Form.Item>

                    {!showWaCode ? (
                        <Form.Item>
                            <Button
                                type="default"
                                style={{ width: '100%', backgroundColor: '#25D366', color: 'white', borderColor: '#25D366' }}
                                loading={waLoading}
                                onClick={handleWhatsappCode}
                                icon="whats-app"
                            >
                                Login with WhatsApp
                            </Button>
                        </Form.Item>
                    ) : (
                        <>
                            <Form.Item>
                                {getFieldDecorator('waCode', {
                                    rules: [{ required: true, message: 'Please input WhatsApp code!' }],
                                })(
                                    <Input
                                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="WhatsApp Code"
                                    />
                                )}
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    style={{ width: '100%' }}
                                    loading={waLoading}
                                    onClick={handleWhatsappLogin}
                                >
                                    Process
                                </Button>
                                <Button
                                    type="link"
                                    style={{ width: '100%', marginTop: '10px' }}
                                    onClick={() => setShowWaCode(false)}
                                >
                                    Back
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form>
            </Card>
        </div>
    );
}

export default Form.create({ name: 'login-form' })(PageLogin);